var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "WebAuth.TwitterRequestTokenPro",
    "options": {
        "objc_class_prefix": "WebAuthTwitterRequestTokenPro",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "callback",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "token",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "tokenSecret",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "callbackConfirmed",
                    "id": 3
                }
            ]
        }
    ]
}).build();
export default _root;



// WEBPACK FOOTER //
// ./js/pb/webauthtwitterrequesttokenpro.pb.js